import { render, staticRenderFns } from "./MyMeals.vue?vue&type=template&id=7cd094b1&scoped=true&"
import script from "./MyMeals.vue?vue&type=script&lang=js&"
export * from "./MyMeals.vue?vue&type=script&lang=js&"
import style0 from "./MyMeals.scss?vue&type=style&index=0&id=7cd094b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd094b1",
  null
  
)

export default component.exports